import { render, staticRenderFns } from "./ModalDescricoesFavoritas.vue?vue&type=template&id=fd1c25e0&"
import script from "./ModalDescricoesFavoritas.vue?vue&type=script&lang=js&"
export * from "./ModalDescricoesFavoritas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports